import { Layout, Menu, Spin } from 'antd';
import routesMap from '../routesMap';
import { trim } from 'lodash';
import React, { useMemo, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Waiter } from 'react-wait';
// import { getDataStorage, STORAGE_KEY } from 'utils/storage';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';

const { Content, Sider } = Layout;

const AdminLayout: React.FC = () => {
    const isLogged = useMemo(() => {
      const item = localStorage.getItem('access_token');
      if (item) {
        const access_token = JSON.parse(item);
        if (new Date().getTime() > access_token.expiry) {
          localStorage.removeItem('access_token');
          return false;
        }
        return true;
      }
      return false;
    }, []);

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  return isLogged ? (
    <Layout className="min-h-screen">
      <AppHeader isMobile={isMobile} onToggleSidebar={() => setCollapsed(!collapsed)} />
      <Layout style={{ background: '#FFF7F9' }}>
        <Sider
          width={220}
          breakpoint="lg"
          collapsedWidth={0}
          trigger={null}
          collapsed={collapsed}
          onBreakpoint={(broken) => {
            setIsMobile(broken);
            setCollapsed(broken);
          }}
        >
          <AppSidebar isMobile={isMobile} onNavigate={() => isMobile && setCollapsed(true)} />
        </Sider>
        <Content className="px-4 py-4 sm:px-6 sm:py-6" style={{ minWidth: 0 }}>
          <Waiter>
            <React.Suspense
              fallback={
                <div className="flex items-center justify-center" style={{ height: '60vh' }}>
                  <Spin size="large" />
                </div>
              }
            >
              <Outlet />
            </React.Suspense>
          </Waiter>
        </Content>
      </Layout>
    </Layout>
  ) : (
    <Navigate to={"/auth/login"} />
  );
};

export default AdminLayout;
export * from './useRoutes';